import {
  captureException,
  flush,
  getClient,
  getTraceMetaTags,
  GLOBAL_OBJ,
  logger,
  vercelWaitUntil
} from "@sentry/core";
export function extractErrorContext(errorContext) {
  const ctx = {};
  if (!errorContext) {
    return ctx;
  }
  if (errorContext.event) {
    ctx.method = errorContext.event._method;
    ctx.path = errorContext.event._path;
  }
  if (Array.isArray(errorContext.tags)) {
    ctx.tags = errorContext.tags;
  }
  return ctx;
}
export function addSentryTracingMetaTags(head, traceData) {
  const metaTags = getTraceMetaTags(traceData);
  if (head.some((tag) => tag.includes("meta") && tag.includes("sentry-trace"))) {
    logger.warn(
      "Skipping addition of meta tags. Sentry tracing meta tags are already present in HTML page. Make sure to only set up Sentry once on the server-side. "
    );
    return;
  }
  if (metaTags) {
    logger.log("Adding Sentry tracing meta tags to HTML page:", metaTags);
    head.push(metaTags);
  }
}
export function reportNuxtError(options) {
  const { error, instance, info } = options;
  const metadata = {
    info
    // todo: add component name and trace (like in the vue integration)
  };
  if (instance?.$props) {
    const sentryClient = getClient();
    const sentryOptions = sentryClient ? sentryClient.getOptions() : null;
    if (sentryOptions?.attachProps && instance.$props !== false) {
      metadata.propsData = instance.$props;
    }
  }
  setTimeout(() => {
    captureException(error, {
      captureContext: { contexts: { nuxt: metadata } },
      mechanism: { handled: false }
    });
  });
}
async function flushWithTimeout() {
  try {
    logger.log("Flushing events...");
    await flush(2e3);
    logger.log("Done flushing events");
  } catch (e) {
    logger.log("Error while flushing events:\n", e);
  }
}
export async function flushIfServerless() {
  const isServerless = !!process.env.FUNCTIONS_WORKER_RUNTIME || // Azure Functions
  !!process.env.LAMBDA_TASK_ROOT || // AWS Lambda
  !!process.env.CF_PAGES || // Cloudflare
  !!process.env.VERCEL || !!process.env.NETLIFY;
  if (GLOBAL_OBJ[Symbol.for("@vercel/request-context")]) {
    vercelWaitUntil(flushWithTimeout());
  } else if (isServerless) {
    await flushWithTimeout();
  }
}
